module.exports = __webpack_public_path__ + "media/components/country-flag/static/bg-e6a450cbb49f95705757111feb1b901c.svg";